import { trigger, state, style, transition,
    animate, group, query, stagger, keyframes
} from '@angular/animations';

export const SlideInOutAnimation = [
    trigger('slideInOut', [
        state('in', style({
            'max-height': '650px', 'visibility': 'visible'
        })),
        state('out', style({
            'max-height': '0px', 'visibility': 'hidden'
        })),
        transition('in => out', [group([
            animate('400ms ease-in-out', style({


            })),
            animate('600ms ease-in-out', style({
                'max-height': '0px'
            })),
            animate('700ms ease-in-out', style({
                'visibility': 'hidden'
            }))
        ]
        )]),
        transition('out => in', [group([
            animate('1ms ease-in-out', style({
                'visibility': 'visible'
            })),
            animate('600ms ease-in-out', style({
                'max-height': '500px'
            })),
            animate('800ms ease-in-out', style({
                'opacity': '1'
            }))
        ]
        )])
    ]),
]

export const slideInOutAnimation = trigger('slideInOutAnimation', [
  state('in', style({ transform: 'translateX(0)' })),
  state('outLeft', style({ transform: 'translateX(-100%)' })),
  state('outRight', style({ transform: 'translateX(100%)' })),
  transition('in <=> outLeft', animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')),
  transition('in <=> outRight', animate('500ms cubic-bezier(0.35, 0, 0.25, 1)')),
]);
